export function EventsOpenCtrl (
  $scope,
  $state,
  $translate,
  bookings,
  Dashboard,
  jsonApi,
  messages,
  tableApi,
  workshopAPI
) {
  $scope.bookings      = bookings;
  $scope.loaded        = true;
  $scope.tableCacheKey = 'openBookings';

  $scope.Dashboard = new Dashboard();

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'event_date',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.EVENT_DATE')
        },
        pipe: 'globalDate',
      },
      {
        field : 'display_name',
        header: {
          text: $translate.instant('CUSTOMER_SPACE.CUSTOMER')
        }
      },
      {
        field : 'vehicleDescription',
        header: {
          text: $translate.instant('VEHICLE_SPACE.VEHICLE')
        }
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('BOOKING_SPACE.JOB')
        }
      }
    ],
    empty: {
      text: $translate.instant('BOOKING_SPACE.NO_BOOKINGS')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50, 100 ],
      queryCount: () => workshopAPI.get('/dashboard/widget_stats', [
        jsonApi.parse(localStorage.getItem('dashboardTaxSwitch')) === false
          ? 'false'
          : 'true',
          jsonApi.parse(localStorage.getItem('dashboardMTDSwitch')) === false
          ? 'false'
          : 'true'
        ]).then(data => data.open_bookings)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'event_date'
    })
  };

  $scope.getBookings = ( params ) => {
    return workshopAPI.get('/dashboard/open_bookings_list', [
      params.pageSize,
      params.offset,
      params.field,
      params.direction,
    ])
    .then(bookings => {
      $scope.bookings = bookings;

      $scope.prepBookings($scope.bookings);

      return $scope.bookings;
    });
  };

  $scope.prepBookings = function (bookings) {
    angular.forEach(bookings, job => {
      job.vehicleDescription = `${ job.plate_number || '' } ${ job.make || '' } ${ job.model || '' }`;
    });
  };

  $scope.refresh = function () {
    $state.reload();

    messages.show($translate.instant('JS_SPACE.MESSAGES.REFRESHED'), 'success');
  };

  $scope.onRowClick = function(event) {
    $state.go('app.event', {
      customer_id: event.row.customer_id,
      vehicle_id : event.row.vehicle_id,
      id         : event.row.id
    });
  };

  $scope.prepBookings($scope.bookings);
}